import request from '@/utilsCloud/request'
import port from './port'


// 获取激活码下拉
export function getListSelect(query) {
  return request({
    url: port.course + '/activation/type/listSelect',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}


// 实名认证保存
export function realNameAuthentication(data) {
  return request({
    url: port.biz + '/employee/realNameAuthentication',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'post',
    data: data
  })
}

export function getEmployeeInformation(query) {
  return request({
    url: port.biz + '/employee/getEmployeeInformation',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}

export function getEnterpriseEmployeeDict(query) {
  return request({
    url: port.biz + '/employee/getEnterpriseEmployeeDict',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}

export function updateEmployeeInformation(data) {
  return request({
    url: port.biz + '/employee/updateEmployeeInformation',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'post',
    data: data
  })
}


// 密码修改
export function enterpriseEmployeeModifyPassword(data) {
  return request({
    url: port.biz + '/employee/enterpriseEmployeeModifyPassword',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'post',
    data: data
  })
}


// 获取验证码
export function employeeSendMobile(data) {
  return request({
    url: port.course + '/employee/employeeSendMobile',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'post',
    data: data
  })
}

// 验证密码
export function employeePasswordVerification(data) {
  return request({
    url: port.course + '/employee/employeePasswordVerification',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'post',
    data: data
  })
}

// 验证码定时器
export function employeeMobileVerification(data) {
  return request({
    url: port.course + '/employee/employeeMobileVerification',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'post',
    data: data
  })
}


// 培训记录
export function getTrainingRecordPackagebagList(query) {
  return request({
    url: port.stat + '/statisticsAnalysis/getTrainingRecordPackagebagList',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}


// 激活码列表
export function selectActivationCodeEmpList(query) {
  return request({
    url: port.course + '/activationCodeEmp/selectActivationCodeEmpList',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}


// 激活课程
export function getActiveList(data) {
  return request({
    url: port.course + '/activationCodeEmp/active',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'post',
    data: data
  })
}

// 培训记录
export function getTrainingRecord(query) {
  return request({
    url: port.stat + '/statisticsAnalysis/getTrainingRecord',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}


// 我的证书
export function getPrintTrainingRecord(query) {
  return request({
    url: port.stat + '/certification/getPrintTrainingRecord',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}

// 证书结果
export function getValidityCertificationResult(query) {
  return request({
    url: port.stat + '/certification/getValidityCertificationResult',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}

// 我的收藏
export function exerciseCollectList(query) {
  return request({
    url: port.exam + '/exercise/exerciseCollectList',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}


export function exerciseDetailVerification(query) {
  return request({
    url: port.exam + '/exercise/exerciseDetailVerification',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}

export function exerciseDetails(query) {
  return request({
    url: port.exam + '/exercise/exerciseDetails',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}


/*收藏、取消收藏 */
export function exerciseCollect(data) {
  return request({
    url: port.exam + '/exercise/exerciseCollect',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'post',
    data: data
  })
}

//我的报名
export function getUnderlineRegisterCourseList(query) {
  return request({
    url: port.course + '/enterprise/underline/getUnderlineRegisterCourseList',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}

// 获取学习信息(章节)
export function getEmployeeStudyList(query) {
  return request({
    url: port.course + '/home/getEmployeeStudyList',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/apiCloud/userCenter.js